import FoodItems from './Excercises'
import Orders from './Orders'
import Users from './Users'
import Offers from './Offers'
import Notifications from './Notifications'
import Categories from './Categories'
import firebase from "../firebase"

import React from 'react';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import GroupIcon from '@material-ui/icons/Group';
import FastfoodIcon from '@material-ui/icons/Fastfood';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import AccountCircle from '@material-ui/icons/AccountCircle';
import CategoryIcon from '@material-ui/icons/Category';


const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    profileButton: {
        marginLeft: 36,
    },
    hide: {
        display: 'none',
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
    },
    drawerOpen: {
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerClose: {
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: 'hidden',
        width: theme.spacing(7) + 1,
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9) + 1,
        },
    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
    },
}));

export default function MainDrawer() {
    const classes = useStyles();
    const theme = useTheme();
    const [open, setOpen] = React.useState(false);
    const [mainView, setMainView] = React.useState(<Orders></Orders>);
    const [navTitle, setNavTitle] = React.useState("Orders");

    const [anchorEl, setAnchorEl] = React.useState(null);
    const showProfile = Boolean(anchorEl);

    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };


    const showFoodItems = () => {
        setMainView(<FoodItems></FoodItems>)
        setNavTitle("Food Items")
    }

    const showOrderItems = () => {
        setMainView(<Orders></Orders>)
        setNavTitle("Orders")
    }

    const showUsersItems = () => {
        setMainView(<Users></Users>)
        setNavTitle("Users")
    }

    const showOffersItems = () => {
        setMainView(<Offers></Offers>)
        setNavTitle("Offers")
    }

    const showNotifications = () => {
        setMainView(<Notifications></Notifications>)
        setNavTitle("Notifications")
    }

    const showCategories = () => {
        setMainView(<Categories></Categories>)
        setNavTitle("Categories")
    }

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };


    const logoutUser = () => {
        firebase.auth().signOut().then(function () {
            // Sign-out successful.
        }).catch(function (error) {
            // An error happened.
        });
    }

    const user = firebase.auth().currentUser;

    return (
        <div className={classes.root}>
            <CssBaseline />
            <AppBar
                position="fixed"
                className={clsx(classes.appBar, {
                    [classes.appBarShift]: open,
                })}
            >
                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        onClick={handleDrawerOpen}
                        edge="start"
                        className={clsx(classes.menuButton, {
                            [classes.hide]: open,
                        })}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Typography variant="h6" noWrap>
                        {navTitle}
                    </Typography>
                    <div style={{marginLeft: "auto"}}>
                        <IconButton
                            onClick={handleMenu}
                            color="inherit"
                        >
                        <AccountCircle />
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorEl}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={showProfile}
                            onClose={handleClose}
                        >
                            <MenuItem onClick={logoutUser}>Log Out</MenuItem>
                            {/* <MenuItem onClick={handleClose}>My account</MenuItem> */}
                        </Menu>
                    </div>
                </Toolbar>
            </AppBar>
            <Drawer
                variant="permanent"
                className={clsx(classes.drawer, {
                    [classes.drawerOpen]: open,
                    [classes.drawerClose]: !open,
                })}
                classes={{
                    paper: clsx({
                        [classes.drawerOpen]: open,
                        [classes.drawerClose]: !open,
                    }),
                }}
            >
                <div className={classes.toolbar}>
                    <IconButton onClick={handleDrawerClose}>
                        {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
                    </IconButton>
                </div>
                <Divider />
                <List>
                    <ListItem button onClick={showOrderItems}>
                        <ListItemIcon><InboxIcon /></ListItemIcon>
                        <ListItemText primary={"Orders"} />
                    </ListItem>
                    {user.email === "admin@sanvika.foodzo" ? 
                        <>
                            <ListItem button onClick={showFoodItems}>
                                <ListItemIcon><FastfoodIcon /></ListItemIcon>
                                <ListItemText primary={"Food Items"} />
                            </ListItem>
                            <ListItem button onClick={showUsersItems}>
                                <ListItemIcon><GroupIcon /></ListItemIcon>
                                <ListItemText primary={"Users"} />
                            </ListItem>
                            <ListItem button onClick={showOffersItems}>
                                <ListItemIcon><LocalOfferIcon /></ListItemIcon>
                                <ListItemText primary={"Offers"} />
                            </ListItem>
                            <ListItem button onClick={showNotifications}>
                                <ListItemIcon><NotificationsActiveIcon /></ListItemIcon>
                                <ListItemText primary={"Notifications"} />
                            </ListItem>
                            <ListItem button onClick={showCategories}>
                                <ListItemIcon><CategoryIcon /></ListItemIcon>
                                <ListItemText primary={"Categories"} />
                            </ListItem>
                        </>
                        :
                        <div></div>
                    }
                </List>
                <Divider />
            </Drawer>
            <main className={classes.content}>
                <div className={classes.toolbar} />
                {mainView}
            </main>
        </div>
    );
}

